import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Casting element to HTMLElement to satisfy TypeScript
const rootElement = document.getElementById('root');

if (!rootElement) {
	throw new Error("Failed to find the root element. Ensure index.html has an element with id='root'.");
}

const root = ReactDOM.createRoot(rootElement as HTMLElement);

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

// We keep unregister to avoid caching issues during development
serviceWorker.unregister();
